import type { IntlShape } from 'react-intl'

export const getIntegrationsCategories = (intl: IntlShape) => {
  return {
    all: intl.formatMessage({
      id: 'integrations.page.category.allIntegrations',
      defaultMessage: 'All',
    }),
    analytics: intl.formatMessage({
      id: 'integrations.page.category.analytics',
      defaultMessage: 'Analytics',
    }),
    automations: intl.formatMessage({
      id: 'integrations.page.category.automations',
      defaultMessage: 'Automations',
    }),
    collaboration: intl.formatMessage({
      id: 'integrations.page.category.collaboration',
      defaultMessage: 'Collaboration',
    }),
    engineering: intl.formatMessage({
      id: 'integrations.page.category.engineering',
      defaultMessage: 'Engineering',
    }),
    forms: intl.formatMessage({
      id: 'integrations.page.category.forms',
      defaultMessage: 'Forms',
    }),
    'identity-security': intl.formatMessage({
      id: 'integrations.page.category.identityAndSecurity',
      defaultMessage: 'Identity & Security',
    }),
    marketing: intl.formatMessage({
      id: 'integrations.page.category.marketing',
      defaultMessage: 'Marketing',
    }),
    'media-design': intl.formatMessage({
      id: 'integrations.page.category.mediaAndDesign',
      defaultMessage: 'Media & Design',
    }),
    productivity: intl.formatMessage({
      id: 'integrations.page.category.productivity',
      defaultMessage: 'Productivity',
    }),
    'project-management': intl.formatMessage({
      id: 'integrations.page.category.projectManagement',
      defaultMessage: 'Project Management',
    }),
  }
}
